import React from "react";
import SummaryCard from "./SummaryCard";
import MiniCard from "./MiniCard";

const DashboardSummary = ({ summaryData, miniData }) => {
  return (
    <div className="dashboard-summary">
      {/* LEFT SECTION - KPI Summary Cards */}
      <div className="summary-left">
        {summaryData.map((item, index) => (
          <SummaryCard key={index} {...item} />
        ))}
      </div>

      {/* RIGHT SECTION - Mini Coverage Cards */}
      <div className="summary-right">
        {miniData.map((item, index) => (
          <MiniCard key={index} {...item} />
        ))}
      </div>
    </div>
  );
};

export default DashboardSummary;
